module.exports = "/static/fonts/Framework7Icons-Regular.f7ffdcf.eot";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.eot
// module id = 1121
// module chunks = 2